module.exports = __webpack_public_path__ + "7f20ae9b0938ff5cb6a8d8f3cb7251e5.svg";